export const HMO = {
    leumit: "לאומית",
    clalit: "כללית",
    maccabi: "מכבי",
    meuhedet: "מאוחדת"
  } as const